import axios from 'axios';
import * as Sentry from '@sentry/react';

export const revalidateCache = async (
  slug: string,
  type: string,
  site_url: string
) => {
  try {
    await axios.post(
      site_url.includes('vt')
        ? import.meta.env.VITE_VT_URL + '/api/revalidate'
        : import.meta.env.VITE_TWISTED_URL + '/api/revalidate',
      {
        slug: site_url.includes('vt') ? `${slug}` : `/${type}${slug}`,
        token: site_url.includes('vt')
          ? import.meta.env.VITE_REVALIDATION_VT_TOKEN
          : import.meta.env.VITE_REVALIDATION_TWISTEDFOOD_TOKEN,
      }
    );
  } catch (error) {
    Sentry.captureException(error);
  }
};

export const revalidateClearCache = async (url: string) => {
  try {
    return await axios.post(`https://${new URL(url).hostname}/api/revalidate`, {
      slug: new URL(url).pathname,
      token: url.includes('vt')
        ? import.meta.env.VITE_REVALIDATION_VT_TOKEN
        : import.meta.env.VITE_REVALIDATION_TWISTEDFOOD_TOKEN,
    });
  } catch (error) {
    Sentry.captureException(error);
  }
};
